import React, { useContext, useEffect, useRef, useState} from 'react'
import { IoLocationSharp, IoSearchOutline } from "react-icons/io5";
import { getAvailableVehicles, getListOfAllVehiclesLatLng, getNewVehicleDashboardData, getNoGpsVehiclesList, getOnTripVehicles, getTmsVehicleCounts, getVehicleDashBoardCounts } from '_services';
import StorageService from 'utils/StorageServices/StorageServices';
import Loading from 'pages/Loading';
import { UserContext } from 'context';
// import { io } from "socket.io-client";
import { GPSConfig } from "lib";
import { GpsTracker } from 'components';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Images } from 'constants';
import toast from 'react-hot-toast';
import './vehicledash.css'

//wss://gps.urja360.com

// const socket = io(`${GPSConfig.socketurl}`, {
//     transports: ["websocket", "polling"],
//     reconnectionAttempts: 3,
//     timeout: 5000,
// });

const vehicleGpsTabs = [
    { id: 1, title: "Planned", count: 0 },
    { id: 2, title: "Not Planned", count: 0 },
]

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const VehicleDashboard = () => {

    const query = useQuery();
    const navigate = useNavigate();
    const location = useLocation();
    // const latestRequestId = useRef(0);

    // Query params
    const utz = query.get('utz') || '1';
    const gps = query.get('gps') || '0';
    const plan = query.get('plan') || '0';

    const companyID= StorageService.getCompanyId()

    const { masterData } = useContext(UserContext);
    const [vehicleList, setVehicleList] = useState([]);
    const [allDataVehicles,setAllDataVehicles]= useState([]);
    const [vehicleLoading, setVehicleLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);

    const [utilizationApi, setUtilizationApi] = useState(Number(utz));
    const [gpsStatusActiveTab, setGPSStatusActiveTab] = useState(Number(gps));
    const [planningActiveTab, setPlanningActiveTab] = useState(Number(plan));

    const [activeMarker, setActiveMarker] = useState(null);
    const hoverTimer = useRef(null);

    const [counts, setCounts] = useState({})

    const utilization = [
        { label: "All Vehicle", value: 1, count: counts?.all_vehicles ? counts?.all_vehicles : 0 },
        { label: "On Trip", value: 2, count: counts?.on_trip ? counts?.on_trip : 0 },
        { label: "Available", value: 3, count: counts?.avilable ? counts?.avilable : 0 },
        // { label: "No GPS", value: 4, count: counts?.no_gps_signal ? counts?.no_gps_signal : 0 },
        { label: "Maintainance", value: 5, count: counts?.maintainance ? counts?.maintainance : 0 },
    ]

    const gpsStatus = [
        { id: 0, title: "All", count: counts?.type?.all ? counts?.type?.all : 0 },
        { id: 1, title: "Running", count: counts?.type?.running ? counts?.type?.running : 0 },
        { id: 2, title: "Idle", count: counts?.type?.idle ? counts?.type?.idle : 0 },
        { id: 3, title: "Parked", count: counts?.type?.parked ? counts?.type?.parked : 0 },
        { id: 4, title: "Unreachable",  count: counts?.type?.unreachable ? counts?.type?.unreachable : 0 },
    ]
    
    const [offset, setOffset] = useState(1);
    const [keyward, setKeyward] = useState('')
    const [hasMoreData, setHasMoreData] = useState(true);

    const containerRef = useRef(null);
    const skipApiRef = useRef(false);

    function useDebounce(value, delay = 1000) {
        const [debounced, setDebounced] = useState(value);
        useEffect(() => {
          const id = setTimeout(() => setDebounced(value), delay);
          return () => clearTimeout(id);
        }, [value, delay]);
        return debounced;
      }
      
      const debouncedKeyward = useDebounce(keyward, 1000);

      useEffect(()=>{
        getAllVehicleTotalValues()

      },[])

      useEffect(() => {
        const init = async () => {
            if (skipApiRef.current) {
                skipApiRef.current = false;
                return; 
              }
            setInitialLoading(true);
            await fatchTmsVehicleCounts();
            setInitialLoading(false);
        };
        init();
        getVehicleCounts()
    }, [debouncedKeyward, utilizationApi, gpsStatusActiveTab, planningActiveTab])

    const getVehicleCounts = async () => {
        try {
            let object = {
                companyId: StorageService.getCompanyId(),
                util: utilizationApi
            }
            const res = await getVehicleDashBoardCounts(object);
            if (res?.responseCode === 200) {
                setCounts(res?.data)
            }
            if (res?.responseCode === 400) {
                toast.error(res?.error);
            }
        } catch (error) {
            // throw error;
        }
    }

    const getAllVehicleTotalValues = async () => {
        try {
            let object = {
                companyId: companyID,
            }
            const res = await getListOfAllVehiclesLatLng(object);
            if (res?.responseCode === 200) {
                // setCounts(res?.data)
                setAllDataVehicles(res?.data)
            }
            if (res?.responseCode === 400) {
                toast.error(res?.error);
            }
        } catch (error) {
            // throw error;
        }
    }

    // useEffect(() => {
    //     getVehicleCounts()
    // }, [utilizationApi, debouncedKeyward])

    const fatchTmsVehicleCounts = async () => {
        if (vehicleLoading || !hasMoreData) return;

        setVehicleLoading(true);
        try {
            let object = {
                companyId: StorageService.getCompanyId(),
                page: offset,
                limit: 20,
            };
            let query = {
                type: gpsStatusActiveTab,
                search: debouncedKeyward || ""
            }

            if (utilizationApi === 1) {
                const res = await getNewVehicleDashboardData(object, query);
                if (res?.responseCode === 404) {
                    return setVehicleList([]);
                }

                if (res?.responseCode === 200) {
                    const vehicles = res?.data || [];
                    const totalRecord = res?.totalResults || 0;

                    if (vehicleList.length + vehicles.length >= totalRecord) {
                        setHasMoreData(false);
                    }

                    setOffset(prev => prev + 1);

                    setVehicleList((prevList) => {
                        const prevStartPoints = {};
                        prevList?.forEach(vehicle => {
                            if (vehicle?.start_latitude && vehicle?.start_longitude) {
                                prevStartPoints[vehicle._id] = {
                                    lat: vehicle.start_latitude,
                                    lng: vehicle.start_longitude
                                };
                            }
                        });

                        const updatedVehicles = vehicles.map((vehicle) => {
                            const gps = vehicle;
                            const gps1 = vehicle?.coordinates;
                            if (!gps1?.latitude || !gps1?.longitude) return vehicle;

                            const lat = parseFloat(gps1.lat);
                            const lng = parseFloat(gps1.lng);
                            const existingStart = prevStartPoints[vehicle.id];

                            return {
                                ...vehicle,
                                start_latitude: existingStart?.lat ?? lat,
                                start_longitude: existingStart?.lng ?? lng,
                            };
                        });

                        return [...prevList, ...updatedVehicles];
                    });
                }
            }

            if (utilizationApi === 2) {
                const res = await getOnTripVehicles(object, query);
                if (res?.responseCode === 404) {
                    return setVehicleList([]);
                }

                if (res?.responseCode === 200) {
                    const vehicles = res?.data || [];
                    const totalRecord = res?.totalResults || 0;

                    if (vehicleList.length + vehicles.length >= totalRecord) {
                        setHasMoreData(false);
                    }

                    setOffset(prev => prev + 1);

                    setVehicleList((prevList) => {
                        const prevStartPoints = {};
                        prevList?.forEach(vehicle => {
                            if (vehicle?.start_latitude && vehicle?.start_longitude) {
                                prevStartPoints[vehicle._id] = {
                                    lat: vehicle.start_latitude,
                                    lng: vehicle.start_longitude
                                };
                            }
                        });

                        const updatedVehicles = vehicles.map((vehicle) => {
                            const gps = vehicle;
                            const gps1 = vehicle?.coordinates;
                            if (!gps1?.latitude || !gps1?.longitude) return vehicle;

                            const lat = parseFloat(gps1.lat);
                            const lng = parseFloat(gps1.lng);
                            const existingStart = prevStartPoints[vehicle.id];

                            return {
                                ...vehicle,
                                start_latitude: existingStart?.lat ?? lat,
                                start_longitude: existingStart?.lng ?? lng,
                            };
                        });

                        return [...prevList, ...updatedVehicles];
                    });
                }
            }

            if (utilizationApi === 3) {
                const res = await getAvailableVehicles(object, query);
                if (res?.responseCode === 404) {
                    return setVehicleList([]);
                }

                if (res?.responseCode === 200) {
                    const vehicles = res?.data || [];
                    const totalRecord = res?.totalResults || 0;

                    if (vehicleList.length + vehicles.length >= totalRecord) {
                        setHasMoreData(false);
                    }

                    setOffset(prev => prev + 1);

                    setVehicleList((prevList) => {
                        const prevStartPoints = {};
                        prevList?.forEach(vehicle => {
                            if (vehicle?.start_latitude && vehicle?.start_longitude) {
                                prevStartPoints[vehicle._id] = {
                                    lat: vehicle.start_latitude,
                                    lng: vehicle.start_longitude
                                };
                            }
                        });

                        const updatedVehicles = vehicles.map((vehicle) => {
                            const gps = vehicle;
                            const gps1 = vehicle?.coordinates;
                            if (!gps1?.latitude || !gps1?.longitude) return vehicle;

                            const lat = parseFloat(gps1.lat);
                            const lng = parseFloat(gps1.lng);
                            const existingStart = prevStartPoints[vehicle.id];

                            return {
                                ...vehicle,
                                start_latitude: existingStart?.lat ?? lat,
                                start_longitude: existingStart?.lng ?? lng,
                            };
                        });

                        return [...prevList, ...updatedVehicles];
                    });
                }
            }

            // if (utilizationApi === 4) {
            //     const res = await getNoGpsVehiclesList(object, query);
            //     if (res?.responseCode === 404) {
            //         return setVehicleList([]);
            //     }

            //     if (res?.responseCode === 200) {
            //         const vehicles = res?.data || [];
            //         const totalRecord = res?.totalResults || 0;

            //         if (vehicleList.length + vehicles.length >= totalRecord) {
            //             setHasMoreData(false);
            //         }

            //         setOffset(prev => prev + 1);

            //         setVehicleList((prevList) => {
            //             const prevStartPoints = {};
            //             prevList?.forEach(vehicle => {
            //                 if (vehicle?.start_latitude && vehicle?.start_longitude) {
            //                     prevStartPoints[vehicle._id] = {
            //                         lat: vehicle.start_latitude,
            //                         lng: vehicle.start_longitude
            //                     };
            //                 }
            //             });

            //             const updatedVehicles = vehicles.map((vehicle) => {
            //                 const gps = vehicle;
            //                 const gps1 = vehicle?.coordinates;
            //                 if (!gps1?.latitude || !gps1?.longitude) return vehicle;

            //                 const lat = parseFloat(gps1.lat);
            //                 const lng = parseFloat(gps1.lng);
            //                 const existingStart = prevStartPoints[vehicle.id];

            //                 return {
            //                     ...vehicle,
            //                     start_latitude: existingStart?.lat ?? lat,
            //                     start_longitude: existingStart?.lng ?? lng,
            //                 };
            //             });

            //             return [...prevList, ...updatedVehicles];
            //         });
            //     }
            // }
        } catch (error) {
            // toast.error(res?.error);
            console.error("Error fetching vehicles", error);
        } finally {
            setVehicleLoading(false);
        }
    };

    const handleScroll = () => {
        const el = containerRef.current;
        if (!el) return;

        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50) {
            fatchTmsVehicleCounts();
        }
    };

    const setInitial = () => {
        setVehicleList([])
        setOffset(1)
        setVehicleLoading(false);
        setHasMoreData(true)
    }

    const searchVehicle = (e) => {
        const value = e.target.value
        setInitial()
        setKeyward(value)
    }

    const utilizationHandler = (value) => {
        setInitial();
        setUtilizationApi(value);
        setGPSStatusActiveTab(0);
        const params = new URLSearchParams(location.search);
        params.set('utz', value);
        params.set('gps', 0);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    const gpsHandler = (value) => {
        setInitial();
        setGPSStatusActiveTab(value);
        const params = new URLSearchParams(location.search);
        params.set('gps', value);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    const planHandler = (value) => {
        setPlanningActiveTab(value)
        const params = new URLSearchParams(location.search);
        params.set('plan', value);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    return (
        <div className='_vehiCle_dash_main'>

            <div className='__utilAd_gpsBx'>

                <div className='__util_sepBx'>
                    <p>Utilization</p>
                    <div className='addPr_flBx _indentView'>
                        <ul className="nav nav-tabs cstNew_tabs px-0" id="utilization" role="utilization">
                            {utilization?.length > 0 ? utilization?.map((item, indx) => (
                                <li
                                    className="nav-item"
                                    role="presentation"
                                    key={item?.label + indx + item?.value}
                                >
                                    <button
                                        className={
                                            "nav-link " + (utilizationApi === item?.value ? "active" : "")
                                        }
                                        type="button"
                                        aria-selected={utilizationApi === item?.value}
                                        onClick={(e) => utilizationHandler(item?.value)}
                                        disabled={vehicleLoading}
                                    // onClick={(e) => fetchUti(item.value)}
                                    // disabled={loading}
                                    >
                                        <span className=''>{item?.label}</span>
                                        <span className=''>{item?.count} </span>

                                    </button>
                                </li>
                            )) : <span className='loading_fts_lkd'>Loading...</span>}
                        </ul>
                    </div>
                </div>

                <div className='__util_sepBx'>
                    <p>GPS Status</p>
                    <div className='addPr_flBx _indentView'>
                        <ul className="nav nav-tabs cstNew_tabs px-0" id="gpsStatus" role="tabGPSStatus">
                            {gpsStatus?.length > 0 ? gpsStatus?.map((item, indx) => (
                                <li
                                    className="nav-item"
                                    role="presentation"
                                    key={item?.title + indx + item?.value}
                                >
                                    <button
                                        className={
                                            "nav-link " + (gpsStatusActiveTab === item?.id ? "active" : "")
                                        }
                                        type="button"
                                        aria-selected={gpsStatusActiveTab === item?.id}
                                        onClick={() => {
                                            if (item?.count === 0) {
                                              skipApiRef.current = true;
                                            }
                                            setGPSStatusActiveTab(item.id);
                                            setVehicleList([])
                                            if (item?.count > 0) {
                                              gpsHandler(item.id);
                                            }
                                          }}
                                        disabled={vehicleLoading}
                                    >
                                        <span className=''>{item?.title}</span>
                                        <span className=''>{item?.count} </span>

                                    </button>
                                </li>
                            )) : <span className='loading_fts_lkd'>Loading...</span>}
                        </ul>
                    </div>
                </div>

                <div className='__util_sepBx'>
                    <p>Planning</p>
                    <div className='addPr_flBx _indentView'>
                        <ul className="nav nav-tabs cstNew_tabs px-0" id="planning" role="tabPlanning">
                            {vehicleGpsTabs?.length > 0 ? vehicleGpsTabs?.map((item, indx) => (
                                <li
                                    className="nav-item"
                                    role="presentation"
                                    key={item?.title + indx + item?.value}
                                >
                                    <button
                                        className={
                                            "nav-link " + (planningActiveTab === item?.id ? "active" : "")
                                        }
                                        type="button"
                                        aria-selected={planningActiveTab === item?.id}
                                        onClick={(e) => planHandler(item.id)}
                                    // disabled={loading}
                                    >
                                        <span className=''>{item?.title}</span>
                                        {/* <span className=''>{item?.count} </span> */}
                                    </button>
                                </li>
                            )) : <span className='loading_fts_lkd'>Loading...</span>}
                        </ul>
                    </div>
                </div>
            </div>

            <div className='_vehiCle_dash_mapPart'>

                <div className='__vhl_leftPart'>
                    <div className="reactour__searchBar">
                        <div className="pos-rel w-100">
                            <input type="text" className="_vehCle_search" placeholder='Search Vehicle or Location'
                                onChange={(e) => searchVehicle(e)}
                            />
                            <span className="pos-abs _serIcon"><IoSearchOutline /></span>
                        </div>
                    </div>
                    <div className="pre-scrollable "
                        ref={containerRef}
                        onScroll={handleScroll}
                    // style={{ maxHeight: '500px', overflowY: 'auto' }}
                    >
                        {
                            initialLoading ?
                                <div colSpan="100%" className="loaderBg" style={{ textAlign: "start" }}>
                                    <Loading />
                                </div>
                                :
                                <React.Fragment>
                                    {(vehicleList?.length > 0 ? vehicleList?.map((el, ind) => {
                                        return (
                                            <React.Fragment key={ind}>
                                                <Link
                                                    to={`/dashboard?t=new_gps_timeline&vn=${el?.vehicle_no}&tbn=1&cmid=${el?.company_id}`}
                                                    className={`_realTime_bx ${activeMarker?.id === el.id ? "active-vehicle" : ""}`}

                                                    onMouseEnter={() => {
                                                        hoverTimer.current = setTimeout(() => {
                                                            setActiveMarker({
                                                                id: el.id,
                                                                position: {
                                                                    lat: parseFloat(el?.coordinates?.lat),
                                                                    lng: parseFloat(el?.coordinates?.lng),
                                                                },
                                                                gps: el,
                                                                vehicle: el,
                                                            });
                                                        }, 1000); // 2 seconds
                                                    }}
                                                    onMouseLeave={() => {
                                                        clearTimeout(hoverTimer.current);
                                                        setActiveMarker(null)
                                                    }}
                                                >
                                                    <div className='d-flex justify-content-between flex-wrap align-items-start' style={{ marginBottom: '12px' }}>
                                                        <div className='__realTime_bx__top'>
                                                            <div className='__kmphBx'>
                                                                <div className='__kmSpeed'><p>{el?.speed}</p></div>
                                                                <div className='__kmphInner'>Kmph</div>
                                                            </div>

                                                            <div className='__realTime_vhl'>
                                                                <h4>{el?.vehicle_no && el?.vehicle_no}</h4>
                                                                <p><span>{el?.summary?.latest_timeline_record?.status} since {el?.summary?.latest_timeline_record?.duration ? el?.summary?.latest_timeline_record?.duration : ''}</span> {el?.summary?.total_covered_dist_today ? `| ${el?.summary?.total_covered_dist_today} KM Today` : `| 0 KM Today`}</p>
                                                            </div>
                                                        </div>

                                                        <div className='__whlTag'><span>{el?.provider}</span></div>
                                                    </div>

                                                    <div>
                                                        <div className='__realTime_bx__bottom'>
                                                            <div className='d-flex gap-1'>
                                                                <span className='__locIcon'><IoLocationSharp /></span>
                                                                <div className='__realTime_bx__bottom__loc'>
                                                                    <h6>{el?.location}</h6>
                                                                    <p>Last updated on {el?.dttime}</p>
                                                                </div>
                                                            </div>

                                                            {el?.fleet_trip != null ?
                                                                <>
                                                                    <div className='__realTime_bx__bottom__trip'>
                                                                        <span style={{ backgroundColor: '#FFAC05' }}></span>
                                                                        <p>{el?.fleet_trip?.trip_status ? masterData.trip_status[el?.fleet_trip?.trip_status] : '-'} &nbsp; #TRIP {el?.fleet_trip?.trip_no ? el?.fleet_trip?.trip_no : '-'} - {el?.fleet_trip?.route_name ? el?.fleet_trip?.route_name : '-'}</p>
                                                                    </div>
                                                                    <div className='__realTime_bx__bottom__trip'>
                                                                        &nbsp; <p> Driver Name - {el?.fleet_trip?.fleet_handler?.name ? el?.fleet_trip?.fleet_handler?.name : ''} &nbsp; Phone {el?.fleet_trip?.fleet_handler?.phone ? el?.fleet_trip?.fleet_handler?.phone : '-'} </p>
                                                                    </div>
                                                                </>
                                                                : <></>
                                                                // <div className='__realTime_bx__bottom__trip'>
                                                                //     <span style={{ backgroundColor: '#3E9828' }}></span>
                                                                //     <p>{el?.vehicle_status ? masterData.vehicle_status[el?.vehicle_status] : '-'} </p>
                                                                // </div>
                                                            }
                                                        </div>

                                                        <div className='__nxtTrip'>
                                                            <span style={{ opacity: '0.5' }}>Next Trip- </span> <span style={{ opacity: '0.8' }}>Not Planned</span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </React.Fragment>
                                        )
                                    }) :
                                        // <span className='fonts_cts'> No data found </span>
                                        // <tr style={{ display: 'flex', justifyContent: 'center' }}>
                                        //     <td colSpan={10} style={{ textAlign: 'center' }}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                                    <img src={Images.NoRecordFound} alt="" />
                                                </div>
                                    )}
                                    <React.Fragment>
                                        {vehicleLoading && (
                                            <div style={{ textAlign: "center", padding: "10px" }}>
                                                loading...
                                            </div>
                                        )
                                        }
                                    </React.Fragment>
                                </React.Fragment>
                        }


                    </div>
                </div>
                <div className='__vhl_rightPart'>
                    <div style={{ minHeight: '100%', width: '100%', position: 'relative' }}>
                        <div style={{ width: "100%", height: "100%", position: 'relative' }}>
                            <GpsTracker vehicleList={allDataVehicles} activeMarker={activeMarker} setActiveMarker={setActiveMarker} />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default VehicleDashboard